// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3Ot3N","icon":"icon-228eU"};